export function getAdminEvents(serviceId) {
	return [
		{
			eventType: 'ServiceModel',
			actionTypes: ['PROPERTIES_UPDATE', 'MODEL_DELETE', 'MODEL_UPDATE'],
			serviceId: serviceId,
		},
	];
}
